import "./Ecosystem.module.css";
import Header from "@/reusable_sections/Header";
import TheAizahcareRealWorldEcosystem from "./sections/TheAizahcareRealWorldEcosystem";
import EcosystemExpansion from "./sections/EcosystemExpansion";
import Footer from "@/reusable_sections/Footer";
export default function EcosystemPage() {
  return <div>
      <Header />
      <TheAizahcareRealWorldEcosystem />
      <EcosystemExpansion />
      <Footer />
    </div>;
}